import React, { useEffect, useState } from 'react'
import jsPDF from "jspdf"
import Navigation from '../screens/Navigation.jsx';
import { wfont } from './Sketch Gothic School-normal';
import { fonnt } from './HEIDH___-normal';
import { fontzap } from './Zapfino-new';
import { fontt } from "./Zapfino-normal";
import { subdir, wwwdir, logo, logowww } from "./logo";
import QRCode from 'qrcode';
import axios from "axios";
import { parseISO, format } from "date-fns";
import { registerLocale } from "react-datepicker";
import { useParams } from 'react-router-dom';
import es from 'date-fns/locale/es';
// import { isAuth } from '../helpers/auth';
registerLocale('es', es);

const ExportToPdf = () => {

  const [formData, setFormData] = useState();

  const { idcurse, iduser } = useParams();

  // const { email, password1, ip } = formData;

  useEffect(() => {
    console.log(idcurse, iduser)
    GetDiploma()
  }, []);

  const GetDiploma = async () => {
    // console.log(formData)
    await axios.get(`${process.env.REACT_APP_API_URL}/tasks/test/diploma/get/${iduser}/${idcurse}`)
      .then((www) => {
        setFormData(www.data[0])
        // console.log(formData)
      }).catch((error) => { console.log("ERROR", error.response) })
  }


  const [qrBase64, setQrBase64] = useState('');
  // // const [today, setToday] = useState(new Date());

  QRCode.toDataURL(`${process.env.REACT_APP_env}:3000/diploma/`, {
    errorCorrectionLevel: 'H', // Can be 'L', 'M', 'Q', 'H' or 'low', 'medium', 'quartile', 'high'
    margin: 2,
    // color: {
    //   dark: '#ffffffff',
    //   light: '#0d2539ff'
    // }
  })
    .then(url => {
      setQrBase64(url);
    })
    .catch(err => {
      console.error(err);
    });

  const createRows = (count) => {
    const rows = [];
    for (let i = 1; i <= count; i++) {
      rows.push([new Date(), `Name ${i}`, `Email ${new Date()}`])
    }
    return rows;
  }


  const onchange = async () => {
    console.log(formData)

    var neww = []
    for (var i = 0; i < formData.units.length; i++) {
      neww.push([{ content: `${formData.units[i].title.toUpperCase()} ${format(parseISO(formData.units[i].createdAt), "d 'de' MMMM 'de' yyyy, HH:mm", { locale: es })}`, colSpan: 3, styles: { halign: 'center', font: 'courier', fillColor: [240, 240, 150] } }]);
      for (var j = 0; j < formData.units[i].themes.length; j++) {
        // console.log(formData.units[i].themes[j])
        var www = [formData.units[i].themes[j].title, formData.units[i].themes[j].idtheme, format(parseISO(formData.units[i].createdAt), "d 'de' MMMM 'de' yyyy, HH:mm", { locale: es })]
        neww.push(www);
      }
    }



    const doc = new jsPDF({ unit: 'cm', orientation: "landscape", format: [32, 21] })

    doc.addFileToVFS('Sketch Gothic School-normal.ttf', wfont);
    doc.addFont('Sketch Gothic School-normal.ttf', 'Sketch Gothic School', 'normal');

    doc.addFileToVFS('HEIDH___-normal.ttf', fonnt);
    doc.addFont('HEIDH___-normal.ttf', 'HEIDH___', 'normal');

    // doc.addFileToVFS('Pauls Swirly Gothic Font-normal.ttf', fontneww);
    // doc.addFont('Pauls Swirly Gothic Font-normal.ttf', 'Pauls Swirly Gothic Font', 'normal');

    // doc.addFileToVFS('Lucida Calligra Regular-normal.ttf', font);
    // doc.addFont('Lucida Calligra Regular-normal.ttf', 'Lucida Calligra Regular', 'normal');

    // doc.addFileToVFS('Zapfino Extra LT Ligatures-normal.otf', fontww);
    // doc.addFont('Zapfino Extra LT Ligatures-normal.otf', 'Zapfino Extra LT Ligatures', 'normal');


    // doc.addFileToVFS('sketch_gothic_school-normal.ttf', fontnew);
    // doc.addFont('sketch_gothic_school-normal.ttf', 'sketch_gothic_school', 'normal');


    doc.addFileToVFS('Zapfino.ttf', fontt);
    doc.addFont('Zapfino.ttf', 'Zapfino', 'normal');


    doc.addFileToVFS('zapfino-extra-lt-two_vq9Lj-normal.ttf', fontzap);
    doc.addFont('zapfino-extra-lt-two_vq9Lj-normal.ttf', 'zapfino-extra-lt-two_vq9Lj', 'normal');

    const opacityState = new doc.GState({ opacity: 0.8 });
    doc.setGState(opacityState);


    doc.advancedAPI(() => {
      doc.saveGraphicsState();
      // Use DOMMatrix to create a transformation matrix (translate, rotate, scale)
      let { a, b, c, d, e, f } = new DOMMatrix()
        .translate(-1, doc.internal.pageSize.height / 2)
        .rotate(-45);

      doc.setCurrentTransformationMatrix(doc.Matrix(a, b, c, d, e, f));
      // Draw the shape at a relative origin (e.g., 0, 0)
      for (let i = 1; i < 11; i++) {
        // doc.rect(0, 0, doc.internal.pageSize.width, doc.internal.pageSize.height, 'S');
        doc.setLineWidth(.5 - (.5 - .01) / i)
        doc.setDrawColor(55, 35, 15 * (5 * i))
        // doc.setDrawColor(255, 155, 55 * (5 * i))
        doc.setFillColor(155, 155, 155)
        // let offset = 10;
        doc.roundedRect(-9 + i, -1 + i, 36 - (2 * i), 23 - (2 * i), 2, 2, 'S');
        // doc.setDrawColor(255, 155, 255)
        // doc.rect(0, 0, doc.internal.pageSize.width - i, doc.internal.pageSize.height - i, 'S');
      }
      doc.fill();
      doc.restoreGraphicsState();
    })

    doc.setLineWidth(.045)
    doc.setFillColor(255, 255, 255)

    doc.setDrawColor(255, 255, 255)
    doc.roundedRect(.5, .5, doc.internal.pageSize.width - 1, doc.internal.pageSize.height - 1, 1, 1, 'S')
    doc.setDrawColor('#0000FF')
    doc.roundedRect(1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2, 1, 1, 'FD')



    const widthh = doc.internal.pageSize.width
    const heightt = doc.internal.pageSize.height

    doc.setFont("Sketch Gothic School");
    // doc.setFont("HEIDH___");
    var ytag = 2.6;
    doc.setFontSize(23)
    var splittedText = doc.splitTextToSize(formData.institute, 3 * widthh / 5)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight
    doc.text(splittedText, widthh / 2, ytag, { maxWidth: 3 * widthh / 5, align: 'center' })
    ytag += blockHeight + .5

    doc.setFont("helvetica", "normal")
    // doc.setFont('courier', 'normal')
    doc.setFontSize(15)
    var splittedText = doc.splitTextToSize("OTORGA EL PRESENTE DIPLOMA A", 2 * widthh / 3)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight
    doc.text(splittedText, widthh / 2, ytag, { maxWidth: 2 * widthh / 3, align: 'center' })
    ytag += blockHeight + 1

    // doc.setFontSize(21)
    // var splittedText = doc.splitTextToSize("DIPLOMA A", 2 * widthh / 3)
    // var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    // var blockHeight = splittedText.length * lineHeight
    // doc.text(splittedText, widthh / 2, ytag, { maxWidth: 2 * widthh / 3, align: 'center' })
    // ytag += blockHeight + 1.1

    doc.setFont("Sketch Gothic School");
    doc.setFontSize(38)
    var splittedText = doc.splitTextToSize(formData.username, 3 * widthh / 2)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight
    doc.text(splittedText, widthh / 2, ytag, { maxWidth: 3 * widthh / 2, align: 'center' })
    ytag += blockHeight + .1

    doc.setFont("helvetica", "normal")
    // doc.setFont('courier', 'normal')
    const wzw = `Por haber cumplido y aprobado satisfactoriamente los requisitos académicos del DIPLOMADO EN ${formData.title.toUpperCase()}. Desarrollado del ${format(parseISO(formData.dateb), "d 'de' MMMM 'de' yyyy, HH:mm", { locale: es })} al ${format(parseISO(formData.datee), "d 'de' MMMM 'de' yyyy, HH:mm", { locale: es })}, con una intensidad horaria de ${formData.nota} horas. Dado en Huamanga Ayacucho, el ${format(new Date(), "d 'de' MMMM 'de' yyyy, HH:mm", { locale: es })}`

    doc.setFontSize(14)
    doc.text(wzw, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })
    var splittedText = doc.splitTextToSize(wzw, 17 * widthh / 19)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight
    ytag += blockHeight + .5

    doc.text(format(parseISO(formData.dateget), "d 'de' MMMM 'de' yyyy, HH:mm", { locale: es }), widthh - 1.7, ytag, { align: 'right' })

    doc.setFont('courier', 'normal')

    ytag += 1
    doc.text(`ID del curso ${formData.code}`, widthh - 1.7, ytag, { align: 'right' })
    ytag += 1
    doc.text(`ID del usuario ${formData.user}`, widthh - 1.7, ytag, { align: 'right' })
    ytag += 1

    doc.setFont("Zapfino");
    doc.text(process.env.REACT_APP_page, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })

    doc.setFont('courier', 'normal')
    var imLogo = 'data:image/jpeg;base64,' + logo
    doc.addImage(imLogo, 'jpeg', 2, 1.5, 3.5, 3.5, "", 'NONE')
    doc.setFont('courier', 'normal')
    var imLoggo = 'data:image/jpeg;base64,' + logowww
    doc.addImage(imLoggo, 'jpeg', widthh - 5.5, 1.5, 3.5, 3.5, "", 'NONE')

    // (interior) agregar imagen(imageData, formato, x, y, ancho, alto, alias, compresión, rotación)
    var imgData = 'data:image/jpeg;base64,' + wwwdir
    doc.addImage(imgData, 'jpeg', 1.5, 15.2, 8, 3.2, "", 'NONE')
    var imgData2 = 'data:image/jpeg;base64,' + subdir
    doc.addImage(imgData2, 'jpeg', 12.5, 15.2, 8.3, 3.3, "", 'NONE', -1)
    var imgData3 = 'data:image/jpeg;base64,' + wwwdir
    doc.addImage(imgData3, 'png', 22.5, 15.2, 8, 3.2, "", 'NONE', 1)

    // doc.setFont("Zapfino");
    // doc.setFontSize(12)
    // doc.setTextColor("#0f0b38ff");

    doc.text(formData.signature1, 1.2 * widthh / 6, 14.5 * heightt / 16, { maxWidth: 2 * widthh / 6, align: 'center' });
    doc.text(formData.signature2, 3 * widthh / 6, 14.5 * heightt / 16, { maxWidth: 2 * widthh / 6, align: 'center' });
    doc.text(formData.signature3, 4.8 * widthh / 6, 14.5 * heightt / 16, { maxWidth: 2 * widthh / 6, align: 'center' });

    doc.setTextColor(1, 1, 1);







    /////////////////////////////////////////////////////////////////////////////////
    doc.addPage();
    /////////////////////////////////////////////////////////////////////////////////






    doc.advancedAPI(() => {
      doc.saveGraphicsState();
      // Use DOMMatrix to create a transformation matrix (translate, rotate, scale)
      let { a, b, c, d, e, f } = new DOMMatrix()
        .translate(-1, doc.internal.pageSize.height / 2)
        .rotate(-45);

      doc.setCurrentTransformationMatrix(doc.Matrix(a, b, c, d, e, f));
      // Draw the shape at a relative origin (e.g., 0, 0)
      for (let i = 1; i < 11; i++) {
        // doc.rect(0, 0, doc.internal.pageSize.width, doc.internal.pageSize.height, 'S');
        doc.setLineWidth(.5 - (.5 - .01) / i)
        doc.setDrawColor(55, 35, 15 * (5 * i))
        // doc.setDrawColor(255, 155, 55 * (5 * i))
        // doc.setFillColor(155, 155, 55 * (5 * i))
        // let offset = 10;
        doc.roundedRect(-9 + i, -1 + i, 36 - (2 * i), 23 - (2 * i), 2, 2, 'S');
        // doc.setDrawColor(255, 155, 255)
        // doc.rect(0, 0, doc.internal.pageSize.width - i, doc.internal.pageSize.height - i, 'S');
      }
      doc.fill();
      doc.restoreGraphicsState();
    })

    doc.setLineWidth(.03)
    doc.setFillColor(255, 255, 255)
    doc.saveGraphicsState();
    doc.setGState(opacityState);

    doc.setDrawColor(55, 55, 255)
    doc.roundedRect(.5, .5, doc.internal.pageSize.width - 1, doc.internal.pageSize.height - 1, 1, 1, 'S')
    // doc.setDrawColor(155, 35, 0)
    doc.setDrawColor('#2d34bdff')
    doc.roundedRect(1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2, 1, 1, 'FD')

    doc.restoreGraphicsState();

    // doc.setFont('courier', 'normal')
    // var ytag = 2;
    // // doc.setFontSize(21)
    // var splittedText = doc.splitTextToSize(process.env.REACT_APP_institute, 6 * widthh / 7)
    // var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    // var blockHeight = splittedText.length * lineHeight
    // doc.text(splittedText, widthh / 2, ytag, { maxWidth: 6 * widthh / 7, align: 'center' })
    // ytag += blockHeight + 1





    const margin = { left: 1.5, right: 1.5, top: 1.5, bottom: 3, };
    // const rowsCount = 30;
    const sections = 2;
    const spacing = .5;
    // calculate each section width
    const printWidht = doc.internal.pageSize.width - (margin.left + margin.right);
    const sectionWidth = (printWidht - ((sections - 1) * spacing)) / sections;

    // add initial empty page that we will delete later,
    // we need it so when we activate it the next addPage()
    // for the second table page will be on the actial first page
    // doc.addPage();

    doc.autoTable({
      head: [['Tema', 'Código', 'Fecha']],
      body: neww.concat(createRows(5)).concat(neww),
      tableWidth: sectionWidth,
      theme: 'plain', // Opciones: 'striped', 'grid', 'plain'
      margin,
      rowPageBreak: 'avoid', // avoid breaking rows into multiple sections
      didDrawPage({ table, pageNumber }) {
        const docPage = doc.internal.getNumberOfPages();
        const nextShouldWrap = pageNumber % sections;

        if (nextShouldWrap) {
          // move to previous page, so when autoTable calles
          // addPage() it will still be the same current page
          doc.setPage(docPage - 1);

          // change left margin which will controll x position
          table.settings.margin.left += sectionWidth + spacing;
        } else {
          // reset left margin for the first section in every page
          table.settings.margin.left = margin.left;
        }
      }
    });

    // delete unused empty page
    // doc.deletePage(1)




    doc.setFont('courier')
    doc.setTextColor("#0f0b38ff");
    doc.setFontSize(9)
    var imgData3 = 'data:image/jpeg;base64,' + qrBase64.split(',')[1]
    doc.addImage(imgData3, 'png', 26.9, 15.9, 3, 3, "", 'NONE')


    doc.text(formData.institute, 6.2, 18.9, { maxWidth: 1.5 * widthh / 5, align: 'center' })

    doc.text(formData.code, 3 * widthh / 6, 14.7 * heightt / 16, { maxWidth: 2 * widthh / 6, align: 'center' });
    doc.text('Obtener diploma', 5.45 * widthh / 6, 14.7 * heightt / 16, { maxWidth: 1 * widthh / 5, align: 'center' });
    doc.text(`${formData.QR}`, 3 * widthh / 6, 15 * heightt / 16, { maxWidth: 4 * widthh / 5, align: 'center' });




    doc.save('downloaded-pdf-with-image.pdf');

  }

  return (
    <>
      <Navigation />
      <div className="container text-center">
        <button onClick={() => { onchange() }} className='btn btn-outline-primary' style={{ margin: '.1em' }}>IMPRIMIR DIPLOMA

          {formData ? <div className='text-center'>
            {formData.username} {formData.title} {formData.nota}  {formData.QR}  {formData.institute}  {formData.faculty}</div>
            : ''}

        </button >

      </div>
    </>
  )
}

export default ExportToPdf





